import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9da4e45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-flex-1" }
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-full"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-p-[20px]"
}
const _hoisted_4 = { class: "tw-flex" }
const _hoisted_5 = { class: "impact-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "number-lable" }, "4", -1))
const _hoisted_7 = { class: "text-lable" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "number-lable" }, "0", -1))
const _hoisted_9 = { class: "grid-container" }
const _hoisted_10 = {
  key: 0,
  class: "grid-item-number"
}
const _hoisted_11 = { class: "likelihood-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "number-lable" }, "0", -1))
const _hoisted_13 = { class: "text-lable" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "number-lable" }, "4", -1))

import { computed, ref, watch } from "vue";
import store from "@/store";
import { getComponentUiText, processingRiskValue } from "@/utils/utilities";
import {
  arrayDataRiskAssessmentDefault,
  dummyDataRiskAssessment,
} from "@/utils/constants";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthRiskAssessmentChart',
  props: {
  loading: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const checklistGroupMetrics = computed(
  () => store.getters["Recommend/getChecklistGroupMetrics"],
);

const isHaveData = computed(() => {
  return Object.keys(checklistGroupMetrics.value).length;
});

const moreDetail: any = ref(arrayDataRiskAssessmentDefault);

const isLoading = ref(props.loading);

watch(
  () => props.loading,
  (newVal) => {
    isLoading.value = newVal;
  },
);

onMounted(async () => {
  if (isHaveData.value) {
    moreDetail.value = await processingRiskValue(checklistGroupMetrics.value);
  } else {
    moreDetail.value = dummyDataRiskAssessment;
  }
});

watch(
  () => checklistGroupMetrics.value,
  async (newVal) => {
    if (isHaveData.value) {
      moreDetail.value = await processingRiskValue(newVal);
    } else {
      moreDetail.value = dummyDataRiskAssessment;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                "app-dashboard-cyber-health-rise-assessment-impact-text-1",
              )), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreDetail.value, (item, rowIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: rowIndex,
                  class: "grid-item"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.gridItem, (col, colIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: colIndex,
                      class: _normalizeClass(["grid-item-inner", `${col.number ? col.className : 'negligible'}`])
                    }, [
                      (col.number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(col.number), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(getComponentUiText)(
              "app-dashboard-cyber-health-rise-assessment-likelihood-text-1",
            )), 1),
            _hoisted_14
          ])
        ]))
  ]))
}
}

})